import { render } from "./SalesStatistics.vue?vue&type=template&id=509b8dff&scoped=true"
import script from "./SalesStatistics.vue?vue&type=script&lang=js"
export * from "./SalesStatistics.vue?vue&type=script&lang=js"

import "./SalesStatistics.vue?vue&type=style&index=0&id=509b8dff&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509b8dff"]])

export default __exports__